module.exports = __webpack_public_path__ + "img/org1.3c2985a3.png";